<div
  class="product-item"
  id="product-{{ product.definitionId }}"
  [attr.data-test]="'product-' + product.definitionId">
  <div id="product-scroll-anchor-{{ product.definitionId }}" class="scroll-anchor"></div>
  <div class="row no-gutters mb-1 grow-mobile">
    <div class="col-12 col-lg-6">
      <div class="image-wrapper">
        <div
          class="label bestseller"
          *ngIf="product.topSellerProduct && platformInformationService.getCurrentPartner() !== null">
          BEST SELLER
        </div>
        <ng-container *ngIf="product.models?.length > 1 && !isMobile; else imageWithoutModels">
          <a
            [routerLink]="[
              { outlets: { sideBar: [product.definitionId.toString(), product.defaultModelId] } }
            ]"
            queryParamsHandling="merge"
            class="text-primary">
            <img
              height="120"
              width="428"
              src="{{ product.imagePath | platformurl }}"
              alt="{{ product.defaultModelName }}" />
          </a>
        </ng-container>
        <ng-template #imageWithoutModels>
          <img
            height="120"
            width="428"
            src="{{ product.imagePath | platformurl }}"
            alt="{{ product.defaultModelName }}" />
        </ng-template>
      </div>

      <!-- Product title with stars -->
      <div class="label-wrapper">
        <div
          class="label2 comp-10 comp-{{ companyId }} {{ (product | productQuality).classString }}"
          [class.standalone]="
            !showAlpiQualityCategoryDesignation ||
            !product.nameWithMerchantForAcceptedLanguages[translateService.currentLang] ||
            product.name[translateService.currentLang] ===
              product.nameWithMerchantForAcceptedLanguages[translateService.currentLang]
          ">
          <ng-container
            *ngIf="showAlpiQualityCategoryDesignation; else withoutAlpiQualityCategoryDesignation">
            <ng-container *ngIf="!platformInformationService.micrositeConfig; else showForMicrosite">
              <div class="d-inline-flex justify-content-between align-items-center w-100">
                <span>{{ product.name[translateService.currentLang] | modifyStars }}</span>
                <span class="ml-3 d-inline-flex" style="gap: 1px" *ngIf="(product | productQuality).quality">
                  <app-icon
                    [name]="i > (product | productQuality).quality ? 'starOutline' : 'star2'"
                    *ngFor="let i of [1, 2, 3, 4, 5, 6, 7]" />
                </span>
              </div>
              <ng-container
                *ngIf="
                  product.nameWithMerchantForAcceptedLanguages[translateService.currentLang] &&
                  product.name[translateService.currentLang] !==
                    product.nameWithMerchantForAcceptedLanguages[translateService.currentLang]
                ">
                <div class="shop-designation">
                  {{
                    product.nameWithMerchantForAcceptedLanguages[translateService.currentLang] | modifyStars
                  }}
                </div>
              </ng-container>
              <ng-container *ngIf="product.productCategoryId === 1 || product.productCategoryId === 5">
                <small class="d-block" style="font-size: 0.75em">{{
                  'ALPINPRODUCT.list.withPoles' | alpitranslate
                }}</small>
              </ng-container>
            </ng-container>
            <ng-template #showForMicrosite>
              <ng-container
                *ngIf="
                  product.nameWithMerchantForAcceptedLanguages[translateService.currentLang] &&
                    product.name[translateService.currentLang] !==
                      product.nameWithMerchantForAcceptedLanguages[translateService.currentLang];
                  else defaultProductName
                ">
                <div class="d-inline-flex justify-content-between align-items-center w-100">
                  <span>{{
                    product.nameWithMerchantForAcceptedLanguages[translateService.currentLang] | modifyStars
                  }}</span>
                  <span class="ml-3 d-inline-flex" style="gap: 1px" *ngIf="getQuality(product) > 0">
                    <app-icon
                      [name]="i > (product | productQuality).quality ? 'starOutline' : 'star2'"
                      *ngFor="let i of [1, 2, 3, 4, 5, 6, 7]" />
                  </span>
                </div>
              </ng-container>
              <ng-template #defaultProductName>
                <div class="d-inline-flex justify-content-between align-items-center w-100">
                  <span>
                    {{ product.name[translateService.currentLang] | modifyStars }}
                  </span>
                  <span class="ml-3 d-inline-flex" style="gap: 1px" *ngIf="getQuality(product) > 0">
                    <app-icon
                      [name]="i > (product | productQuality).quality ? 'starOutline' : 'star2'"
                      *ngFor="let i of [1, 2, 3, 4, 5, 6, 7]" />
                  </span>
                </div>
              </ng-template>
              <small
                *ngIf="product.productCategoryId === 1 || product.productCategoryId === 5"
                style="font-size: 0.75em"
                >{{ 'ALPINPRODUCT.list.withPoles' | alpitranslate }}</small
              >
            </ng-template>
          </ng-container>

          <ng-template #withoutAlpiQualityCategoryDesignation>
            <ng-container
              *ngIf="
                !product.nameWithMerchantForAcceptedLanguages[translateService.currentLang];
                else merchantName
              ">
              {{ product.name[translateService.currentLang] | modifyStars }}
            </ng-container>
            <ng-template #merchantName>
              {{ product.nameWithMerchantForAcceptedLanguages[translateService.currentLang] | modifyStars }}
            </ng-template>
            <ng-container *ngIf="product.productCategoryId === 1 || product.productCategoryId === 5">
              <br />
              <small style="font-size: 0.75em">{{ 'ALPINPRODUCT.list.withPoles' | alpitranslate }}</small>
            </ng-container>
          </ng-template>
        </div>
      </div>

      <ng-container *ngIf="product.models?.length > 1; else withoutModels">
        <div class="product-item-title d-flex align-items-center">
          <a
            [routerLink]="[
              { outlets: { sideBar: [product.definitionId.toString(), product.defaultModelId] } }
            ]"
            queryParamsHandling="merge"
            class="text-primary">
            {{ product.defaultModelName }}
          </a>
          <span *ngIf="cart.selectedPerson?.discounts?.isFree && product.freeChild" class="free-label">{{
            'ALPINPRODUCT.page.free-child' | alpitranslate
          }}</span>
        </div>
        <div class="product-item-subtitle">
          <span>{{ 'ALPINPRODUCT.list.orSimilarModel' | alpitranslate }}</span>
          <div class="show-all">
            <a
              [routerLink]="[{ outlets: { sideBar: [product.definitionId.toString()] } }]"
              queryParamsHandling="merge"
              class="text-primary d-inline-flex align-items-center">
              <app-icon name="smView" class="text-primary mr-1" />
              {{ 'ALPINPRODUCT.list.showAllModels' | alpitranslate }}
            </a>
          </div>
        </div>
      </ng-container>
      <ng-template #withoutModels>
        <div class="d-flex align-items-center">
          <div class="product-item-title">
            {{ product.defaultModelName }}
          </div>
          <span *ngIf="cart.selectedPerson.discounts?.isFree && product.freeChild" class="free-label">{{
            'ALPINPRODUCT.page.free-child' | alpitranslate
          }}</span>
        </div>
        <div class="product-item-subtitle">
          <span>{{ 'ALPINPRODUCT.list.orSimilarModel' | alpitranslate }}</span>
        </div>
      </ng-template>

      <div
        class="product-description"
        [style.cursor]="toggleDescription !== 'open' ? 'pointer' : null"
        [@clamp]="isMobile ? toggleDescription : 'open'"
        (click)="toggleDescription = 'open'"
        [class.mb-2]="product.descriptionForAcceptedLanguages[translateService.currentLang]?.length < 120">
        {{ product.descriptionForAcceptedLanguages[translateService.currentLang] }}
      </div>
      <div
        class="d-flex justify-content-center mb-3"
        (click)="toggleDescription = 'open'"
        *ngIf="
          isMobile &&
          product.descriptionForAcceptedLanguages[translateService.currentLang]?.length > 120 &&
          toggleDescription === 'closed'
        ">
        <app-icon name="chevronDown" class="c-pointer product-description-expand" />
      </div>
    </div>
    @if (!product.hasStopProduct) {
      <div class="col-12 col-lg-6 mt-auto mt-lg-0">
        <div class="subtitle">{{ 'ALPINPRODUCT.list.additionalOffer' | alpitranslate }}</div>
        <div class="services pr-lg-2 pr-lg-0">
          <ng-container *ngFor="let addon of product.addons; let i = index">
            <div
              *ngIf="!(addon.definitionId === 3 && ['cs', 'sk'].includes(translateService.currentLang))"
              class="service align-items-center d-flex">
              <div class="service-name d-flex align-items-center">
                <app-icon
                  name="infoCircle"
                  class="mr-2 info"
                  *ngIf="isMobile && addon.descriptionForAcceptedLanguages[translateService.currentLang]"
                  [appTooltip]="toolTipContent" />
                <ng-container [ngSwitch]="addon.classname">
                  <app-icon
                    *ngSwitchCase="'boots'"
                    name="boots"
                    class="c-pointer text-primary mr-1"
                    (click)="changeAddon(addon)"
                    data-test="addBootsSwitch" />
                  <app-icon
                    *ngSwitchCase="'helmet'"
                    name="helmet"
                    class="c-pointer text-primary mr-1"
                    (click)="changeAddon(addon)"
                    data-test="addHelmetSwitch" />
                  <app-icon
                    *ngSwitchCase="'depot'"
                    name="depot"
                    class="c-pointer text-primary mr-1"
                    (click)="changeAddon(addon)"
                    data-test="depotSwitch" />
                  <app-icon
                    *ngSwitchCase="'insurance'"
                    name="damage"
                    class="c-pointer text-primary mr-1"
                    (click)="changeAddon(addon)"
                    data-test="damageProtectionSwitch" />
                  <app-icon
                    *ngSwitchCase="'model_change'"
                    name="changeEquipment"
                    class="c-pointer text-primary mr-1"
                    (click)="changeAddon(addon)"
                    data-test="changeEquipmentSwitch" />
                  <app-icon
                    *ngSwitchCase="'priority_checkin'"
                    name="arrowRight"
                    class="c-pointer text-primary mr-1"
                    (click)="changeAddon(addon)" />
                </ng-container>
                <span
                  class="c-pointer"
                  [class.text-primary]="
                    cart.euroBasedRates
                      ? addon.getOnlinePrice(
                          cart.getDurationInDays(),
                          cart.selectedPerson,
                          product,
                          cart.euroBasedRates,
                          currencyService.actualCurrency
                        ).amount === 0
                      : false
                  "
                  (click)="changeAddon(addon)"
                  >{{ 'ALPINPRODUCT.list.addon.name.' + addon.nameTranslationKey | alpitranslate }}</span
                >

                <ng-template #toolTipContent>
                  <div style="pointer-events: auto" class="alpi-tooltip">
                    <ng-container [ngSwitch]="addon.definitionId">
                      <div
                        class="content"
                        *ngSwitchCase="3"
                        [innerHtml]="
                          (platformInformationService.partner
                            ? 'ALPINPRODUCT.list.productFeatureMicrositeInsuranceTooltip'
                            : 'ALPINPRODUCT.list.productFeatureInsuranceTooltip'
                          ) | alpitranslate
                        "></div>
                      <div
                        class="content"
                        *ngSwitchCase="4"
                        [innerHtml]="'ALPINPRODUCT.list.productFeatureDepotTooltip' | alpitranslate"></div>
                      <div
                        class="content"
                        *ngSwitchCase="5"
                        [innerHtml]="
                          'ALPINPRODUCT.list.productFeatureItemChangeTooltip' | alpitranslate
                        "></div>
                      <div
                        class="content"
                        *ngSwitchCase="7"
                        [innerHtml]="
                          'ALPINPRODUCT.list.productFeaturePriorityCheckinTooltip' | alpitranslate
                        "></div>
                    </ng-container>
                  </div>
                </ng-template>
                <app-icon
                  name="infoCircle"
                  class="ml-2 info"
                  *ngIf="!isMobile && addon.definitionId > 2"
                  [appTooltip]="toolTipContent" />
              </div>
              <div class="ml-auto flex-shrink-0">
                @if (cart.selectedPerson.discounts) {
                  @if (
                    addon.getOnlinePrice(
                      cart.getDurationInDays(),
                      cart.selectedPerson,
                      product,
                      cart.euroBasedRates,
                      currencyService.actualCurrency
                    ).amount === 0
                  ) {
                    <span>{{ 'ALPINPRODUCT.list.labelFree' | alpitranslate }}</span>
                  } @else {
                    <strong class="c-pointer" (click)="changeAddon(addon)"
                      >(+{{
                        addon.getOnlinePrice(
                          cart.getDurationInDays(),
                          cart.selectedPerson,
                          product,
                          cart.euroBasedRates,
                          currencyService.actualCurrency
                        ) | alpicurrency: currencyService.actualCurrency
                      }})
                    </strong>
                  }
                } @else {
                  <app-icon style="display: block" name="circleNotch" />
                }
              </div>

              <div class="service-switch ml-2">
                <app-toggle [state]="addon.isSelected" (changedState)="changeAddon(addon)"></app-toggle>
              </div>
            </div>
          </ng-container>
        </div>
      </div>
    } @else {
      <div class="col-12 col-lg-6">
        <div class="unbookable-shop-info text-danger">
          <app-icon name="stop" class="mr-2" />
          {{ 'ALPINPRODUCT.list.productUnavailable' | alpitranslate }}
        </div>
      </div>
    }
  </div>

  <!-- shop price, online price and "add/remove" button -->
  <div class="row no-gutters mt-auto mt-md-1" *ngIf="!product.hasStopProduct">
    <div class="col-12 col-lg-8">
      <div class="row mb-2 discount-details no-gutters">
        <div class="col col-6 text-center">
          <span data-test="productStorePriceLabel" class="discount-title">{{
            'ALPINPRODUCT.list.storePrice' | alpitranslate
          }}</span>
          @if (cart.euroBasedRates) {
            <span data-test="productStorePrice">
              {{
                product.getTotalShopPrice(
                  cart.getDurationInDays(),
                  cart.euroBasedRates,
                  currencyService.actualCurrency
                ) | alpicurrency: currencyService.actualCurrency
              }}</span
            >
          } @else {
            <app-icon name="circleNotch" />
          }
        </div>
        <div class="col col-6 text-center">
          <span data-test="productOnlinePriceLabel" class="discount-title">{{
            'ALPINPRODUCT.list.onlinePrice' | alpitranslate
          }}</span>
          @if (cart.selectedPerson.discounts) {
            <span data-test="productOnlinePrice">
              @if (platformInformationService.isOfficeIp) {
                {{
                  product.getTotalDiscount(
                    cart.getDurationInDays(),
                    cart.selectedPerson,
                    cart.euroBasedRates,
                    currencyService.actualCurrency
                  ) | percent
                }}
              }
              {{
                product.getTotalOnlinePrice(
                  cart.getDurationInDays(),
                  cart.selectedPerson,
                  cart.euroBasedRates,
                  currencyService.actualCurrency
                ) | alpicurrency: currencyService.actualCurrency
              }}
            </span>
          } @else {
            <div class="text-center">
              <app-icon name="circleNotch" />
            </div>
          }
        </div>
      </div>
    </div>
    <div class="col-12 col-lg-4">
      <div class="d-flex justify-content-end">
        @if (isSelected) {
          <div class="d-flex mr-3 align-items-center">
            <app-icon name="tick" class="success-icon text-success" />
          </div>
        }
        <button
          type="button"
          class="btn btn-block btn-primary btn-primary-custom d-flex align-items-center p-2"
          (click)="isSelected ? removeProduct() : selectProductWithSelectedAddons()"
          data-test="addProductToBasket">
          <span class="btn-text mx-auto">{{
            (isSelected ? 'ALPINPRODUCT.list.productRemoveFromCart' : 'ALPINPRODUCT.list.productAddToCart')
              | alpitranslate
          }}</span>

          <app-icon [name]="isSelected ? 'cross' : 'rightArrow'" class="ml-2" />
        </button>
      </div>
    </div>
  </div>
</div>
